// extracted by mini-css-extract-plugin
module.exports = {"container":"persons_container__nRE_J","list":"persons_list__yG3sW","item":"persons_item__djyvM","pinned":"persons_pinned__s1iPK","title":"persons_title__qJvmV"};